<template>
 <!-- left col START -->
    <div class="leftCol">

      <!-- leftcol-banner start -->
      <div class="leftcol-banner">
        <!-- NEW BANNER + TEXT start -->
        <div class="leftcol-banner-content">
          <img src="@/assets/images/banner-1.svg" alt="" />
          <p v-if="$store.state.game">{{$t('league')}} {{$store.state.game.League}}</p>
        </div>
        <!-- NEW BANNER + TEXT stop -->
      </div>
      <!-- leftcol-banner stop -->


      <!-- leftcol-container start -->
      <div class="leftcol-container" v-if="$store.state.game">

        <!-- row start -->
        <div class="row active" v-for="item, key in $store.state.game.Match" @click="getPage(item)">
          <div class="td">{{key+1}}</div>
          <div class="td">
            <div class="icon"><img :src="getimg(item.HomeTeam)" alt=""></div>
          </div>
          <div class="td">{{getteams(item.HomeTeam)}}</div>
          <div class="td">vs</div>
          <div class="td">{{getteams(item.AwayTeam)}}</div>
          <div class="td">
            <div class="icon"><img :src="getimg(item.AwayTeam)" alt=""></div>
          </div>
          <div class="td">
            <div class="triangle" :class="reverse(item)"><img src="@/assets/images/triangle.svg" alt="" /></div>
          </div>
        </div>
        <!-- row stop -->

      </div>
      <!-- leftcol-container stop-->


    </div>
    <!-- left col STOP -->
</template>

<script>
import Vue from 'vue'

export default {
  name: 'LeftCol',
  data: ()=>{
    return {

    }
  },
  methods: {
    getteams(team){
      if(this.$store.state.teams == null) return
      let result = this.$store.state.teams.filter(item => item.id == team);
      return result[0].Abriviation
    },
    getimg(name){
      if(name == null) return
      if(this.$store.state.teams == null) return
      let result = this.$store.state.teams.filter(item => item.id == name);
      if(result[0].Icon != ""){
        return "https://champs-admin.info/gallery/" + result[0].Icon
      }
    },
    getPage(item){
      if(this.$route.name == "MatchDetails" && this.$route.params.HomeTeam == item.HomeTeam ){
        this.$router.push({name: 'MainTab'})
      }else{
        this.$router.push({name: 'MatchDetails', params: item})
      }
    },
    reverse(item){
      if(this.$route.params.HomeTeam == item.HomeTeam ){
        return "reverse"
      }
    }
  }
};

</script>
<style>

</style>